import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import '../styles/Skills.css';

export const Skills = () => {
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  return (
    <section className="skill" id="skills">
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="skill-bx wow zoomIn">
                        <h2>Skills</h2>
                        <p>I have a diverse range of skills in programming and problem-solving, allowing me to <br></br>confidently navigate the world of computer science.</p>
                        <Carousel responsive={responsive} infinite={true} className="owl-carousel owl-theme skill-slider">
                          <div className="item">
                            <div className="centered-item">
                              <div className="outerCircle">
                                <h6>React JS</h6>
                              </div>
                            </div>
                          </div>

                          <div className="item">
                            <div className="centered-item">
                              <div className="outerCircle">
                                <h6>Node JS</h6>
                              </div>
                            </div>
                          </div>

                          <div className="item">
                            <div className="centered-item">
                              <div className="outerCircle">
                                <h6>Responsive Design</h6>
                              </div>
                            </div>
                          </div>

                          <div className="item">
                            <div className="centered-item">
                              <div className="outerCircle">
                                <h6>HTML, CSS, JavaScript</h6>
                              </div>
                            </div>
                          </div>

                          <div className="item">
                            <div className="centered-item">
                              <div className="outerCircle">
                                <h6>Deep Learning</h6>
                              </div>
                            </div>
                          </div>

                          <div className="item">
                            <div className="centered-item">
                              <div className="outerCircle">
                                <h6>Figma</h6>
                              </div>
                            </div>
                          </div>

                          <div className="item">
                            <div className="centered-item">
                              <div className="outerCircle">
                                <h6>Git</h6>
                              </div>
                            </div>
                          </div>
                        </Carousel>
                    </div>
                </div>
            </div>
        </div>
        
    </section>
  )
}
